import { styled } from '@mui/material';

const StyledLessonChunksWrap = styled('ul')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: '24px',
	margin: '0',
	listStyleType: 'none',
	gap: '12px',
	width: '100%',
	marginInline: 'auto',

	[theme.breakpoints.down('sm')]: {
		padding: '16px',
		gap: '8px',
	},

	[theme.breakpoints.down('xs')]: {
		padding: '4px',
	},
}));

export default StyledLessonChunksWrap;
